import React from "react";
import {
  Dialog,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslate } from "src/locales";
import type { PackageAction } from "src/api/request/requestService";

interface PackageActionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (action: PackageAction) => void;
}

/**
 * DELETE_PROCESS_025 hatası geldiğinde gösterilen paket işlem seçim modalı.
 * 3 seçenek sunar: Paketten Çıkar | Tümünü Sil | İptal
 */
const PackageActionModal: React.FC<PackageActionModalProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ p: "20px", display: "flex", flexDirection: "column", gap: "20px" }}>
        {/* Header */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Box sx={{ width: 28, height: 28, position: "relative" }}>
            <img src="/assets/icons/modal/Alert.svg" alt="Alert" style={{ width: "100%", height: "100%" }} />
          </Box>
          <Typography
            sx={{
              flex: 1,
              color: "#333333",
              fontSize: "20px",
              fontFamily: "Poppins",
              fontWeight: 700,
            }}
          >
            {t("request-list.package-action.title", "default", { defaultValue: "Paket İşlem Seçimi" })}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ height: 0, borderBottom: "1px solid #E1E1E1" }} />

        {/* Message */}
        <Typography
          sx={{
            color: "#333333",
            fontSize: "15px",
            fontFamily: "Poppins",
            fontWeight: 400,
          }}
        >
          {t("request-list.package-action.message", "default", {
            defaultValue: "Bu işlem bir pakete aittir. Lütfen bir seçenek belirleyin:",
          })}
        </Typography>

        <Box sx={{ height: 0, borderBottom: "1px solid #E1E1E1" }} />

        {/* Action Buttons */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "12px", flexWrap: "wrap" }}>
          <Button
            onClick={() => onSelect("Cancel")}
            sx={{
              height: "44px",
              padding: "0 14px",
              bgcolor: "#1E88E5",
              color: "white",
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 400,
              textTransform: "none",
              "&:hover": { bgcolor: "#1565C0" },
            }}
          >
            {t("request-list.package-action.cancel", "default", { defaultValue: "Vazgeç" })}
          </Button>
          <Button
            onClick={() => onSelect("MoveOut")}
            sx={{
              height: "44px",
              padding: "0 14px",
              bgcolor: "transparent",
              color: "#2F80ED",
              border: "1px solid #2F80ED",
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 400,
              textTransform: "none",
              "&:hover": { bgcolor: "rgba(47, 128, 237, 0.04)" },
            }}
          >
            {t("request-list.package-action.move-out", "default", { defaultValue: "Paketten Çıkar" })}
          </Button>
          <Button
            onClick={() => onSelect("DeleteAll")}
            sx={{
              height: "44px",
              padding: "0 14px",
              bgcolor: "transparent",
              color: "#d32f2f",
              border: "1px solid #d32f2f",
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 400,
              textTransform: "none",
              "&:hover": { bgcolor: "rgba(211, 47, 47, 0.04)" },
            }}
          >
            {t("request-list.package-action.delete-all", "default", { defaultValue: "Tümünü Sil" })}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PackageActionModal;
